import { useTranslation } from "react-i18next";
import {
  ESenderRole,
  IContractDetailsResponseData,
  Transactions,
} from "../../../../setup/api/services/contract/models";
import PartyTable from "../../create/partyTable";
import { EPARTY_STATUS } from "../../../../enums";
import styles from "./styles.module.scss";
import { findPartyForProfile } from "../../../../setup/util/contract";

interface MainDetailsProps {
  milestone: IContractDetailsResponseData | undefined;
}

const MainDetails = ({ milestone }: MainDetailsProps) => {
  const { t } = useTranslation();

  const getPaymentMethodLabel = (
    transaction: Transactions
  ): string | undefined => {
    if (!transaction) return undefined;
    const method =
      transaction.type === "MANUAL_BANK_TRANSFER"
        ? "MANUAL_BANK_TRANSFER"
        : transaction.paymentMethod;
    if (!method) return undefined;
    switch (method) {
      case "CARD":
        return t("lbl_bank_card");
      case "APPLE_PAY":
        return t("lbl_apple_pay");
      case "STCPAY":
        return t("lbl_stc_pay");
      case "TABBY":
        return t("lbl_pay_with_tabby");
      case "TAMARA":
        return t("lbl_pay_with_tamara");
      case "MANUAL_BANK_TRANSFER":
        return t("lbl_bank_transfer");
      case "CONTRACT_TRANSFER":
        return t("lbl_contract_transfer");
      default:
        return method;
    }
  };

  return (
    <>
      {(milestone?.partiesProfiles?.CUSTOMER || []).length > 0 && (
        <div className={styles.partyContainer}>
          <h2>{t("lbl_payees")}</h2>

          <PartyTable
            detailsPage
            rows={(milestone?.partiesProfiles?.CUSTOMER || [])?.map((party) => {
              const currentParty = findPartyForProfile(
                milestone?.parties,
                party
              );
              const paymentTransaction = milestone?.transactions?.find(
                (transaction) =>
                  transaction?.fromUserId?.toString() ===
                    currentParty?.userId?.toString() &&
                  (transaction?.type === "CUSTOMER_PAY" ||
                    transaction?.type === "MANUAL_BANK_TRANSFER") &&
                  transaction?.status === "SUCCESS"
              );
              return {
                id: party?.id?.toString() || "",
                name: party?.profile?.fullName || "",
                phoneNumber:
                  party?.phoneNumber || currentParty?.phoneNumber || "",
                amount: currentParty?.amount || 0,
                status: currentParty?.status,
                type: "customer",
                fee: 0,
                total: +(currentParty?.fee || 0) + +(currentParty?.amount || 0),
                image: party?.profile?.photoUrl || "",
                paymentMethod: paymentTransaction
                  ? getPaymentMethodLabel(paymentTransaction)
                  : undefined,
              };
            })}
            columns={{
              showActions: false,
              showStatus: true,
              showRole: false,
              showFee: false,
              showTotal: false,
              showPaymentMethod: true,
            }}
            getIndexByRow={(row) =>
              (milestone?.parties || [])?.findIndex(
                (p) => p?.id?.toString() === row?.id
              )
            }
          />
        </div>
      )}

      {(milestone?.partiesProfiles?.PROVIDER || []).length > 0 && (
        <div className={styles.partyContainer}>
          <h2>{t("lbl_receivers")}</h2>

          <PartyTable
            detailsPage
            rows={(milestone?.partiesProfiles?.PROVIDER || [])?.map((party) => {
              const currentParty = findPartyForProfile(
                milestone?.parties,
                party
              );
              return {
                id: party?.id?.toString() || "",
                name: party?.profile?.fullName || "",
                phoneNumber:
                  party?.phoneNumber || currentParty?.phoneNumber || "",
                amount: currentParty?.amount || 0,
                status:
                  milestone?.cashOutAmountList?.find(
                    (item) => item?.userIdentification === currentParty?.userId
                  )?.settlementAmountStatus === EPARTY_STATUS.AVAILABLE_BALANCE
                    ? EPARTY_STATUS.AVAILABLE_BALANCE
                    : currentParty?.status,
                type: "provider",
                fee: 0,
                total: +(currentParty?.fee || 0) + +(currentParty?.amount || 0),
                image: party?.profile?.photoUrl || "",
              };
            })}
            columns={{
              showActions: false,
              showStatus: true,
              showRole: false,
              showFee: false,
              showTotal: false,
            }}
            getIndexByRow={(row) =>
              (milestone?.parties || [])?.findIndex(
                (p) => p?.id?.toString() === row?.id
              )
            }
          />
        </div>
      )}

      {(milestone?.partiesProfiles?.BROKER || []).length > 0 && (
        <div className={styles.partyContainer}>
          <h2>{t("lbl_brokers")}</h2>

          <PartyTable
            detailsPage
            rows={(milestone?.partiesProfiles?.BROKER || [])?.map((party) => {
              const currentParty = milestone?.parties?.find(
                (partyObject) => partyObject?.role === ESenderRole.BROKER
              );
              return {
                id: party?.id?.toString() || "",
                name: party?.profile?.fullName || "",
                phoneNumber:
                  party?.phoneNumber || currentParty?.phoneNumber || "",
                amount: currentParty?.amount || 0,
                status:
                  milestone?.cashOutAmountList?.find(
                    (item) => item?.userIdentification === currentParty?.userId
                  )?.settlementAmountStatus === EPARTY_STATUS.AVAILABLE_BALANCE
                    ? EPARTY_STATUS.AVAILABLE_BALANCE
                    : currentParty?.status,
                type: "provider",
                fee: 0,
                total: +(currentParty?.fee || 0) + +(currentParty?.amount || 0),
                image: party?.profile?.photoUrl || "",
              };
            })}
            columns={{
              showActions: false,
              showStatus: true,
              showRole: false,
              showFee: false,
              showTotal: false,
            }}
            getIndexByRow={(row) =>
              (milestone?.parties || [])?.findIndex(
                (p) => p?.id?.toString() === row?.id
              )
            }
          />
        </div>
      )}
    </>
  );
};

export default MainDetails;
